/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Password_LabelInputs */

const en_auth_password_label = /** @type {(inputs: Auth_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password`)
};

const de_auth_password_label = /** @type {(inputs: Auth_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort`)
};

const fr_auth_password_label = /** @type {(inputs: Auth_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mot de passe`)
};

const es_auth_password_label = /** @type {(inputs: Auth_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contraseña`)
};

const it_auth_password_label = /** @type {(inputs: Auth_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password`)
};

const nl_auth_password_label = /** @type {(inputs: Auth_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wachtwoord`)
};

const pl_auth_password_label = /** @type {(inputs: Auth_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hasło`)
};

const fi_auth_password_label = /** @type {(inputs: Auth_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salasana`)
};

const da_auth_password_label = /** @type {(inputs: Auth_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adgangskode`)
};

const sv_auth_password_label = /** @type {(inputs: Auth_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lösenord`)
};

/**
* | output |
* | --- |
* | "Password" |
*
* @param {Auth_Password_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const auth_password_label = /** @type {((inputs?: Auth_Password_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Password_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_password_label(inputs)
	if (locale === "fr") return fr_auth_password_label(inputs)
	if (locale === "es") return es_auth_password_label(inputs)
	if (locale === "it") return it_auth_password_label(inputs)
	if (locale === "nl") return nl_auth_password_label(inputs)
	if (locale === "pl") return pl_auth_password_label(inputs)
	if (locale === "fi") return fi_auth_password_label(inputs)
	if (locale === "da") return da_auth_password_label(inputs)
	if (locale === "sv") return sv_auth_password_label(inputs)
	return en_auth_password_label(inputs)
});